import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { InlineLinkDarkControl as InlineLink } from '../controls/inline-link-control';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>
  The environment mitigation levy applies only within the MSA Levy Area. Conservation Areas are not included within the
  MSA Levy Area.
    </p>
    <p>
  Twelve precincts (which have precinct structure plans gazetted prior to 1 March 2012) are included within the broader
  MSA program but are not included within the MSA Levy Area. Instead, biodiversity offset requirements are set out in
  the relevant precinct structure plan, native vegetation precinct plan, and any applicable conservation management
  plan. Please contact{' '}
  <InlineLink href="mailto:msa.habitatcompensation@delwp.vic.gov.au" text="msa.habitatcompensation@delwp.vic.gov.au" mdxType="InlineLink" />{' '}
  for land parcel specific information.
    </p>
    <p>
  The tool also identifies land parcels which are subject to DEECA’s Salvage and Translocation Protocol for Melbourne’s
  Growth Corridors. Additional requirements may apply to planning permits on these parcels. More information on salvage
  and translocation is available on the{' '}
  <InlineLink href="https://msa.vic.gov.au/" text="Melbourne Strategic Assessment website" mdxType="InlineLink" />.
    </p>
    <p>
  For information about the requirements of the Melbourne Strategic Assessment (Environment Mitigation Levy) Act 2020,
  the MSA program approvals under section 146B of the Environment Protection and Biodiversity Conservation Act 1999
  (Cth) and the circumstances and areas to which they apply, either refer to the{' '}
  <InlineLink href="https://msa.vic.gov.au/" text="Melbourne Strategic Assessment website" mdxType="InlineLink" /> or contact{' '}
  <InlineLink href="mailto:msa.habitatcompensation@delwp.vic.gov.au" text="msa.habitatcompensation@delwp.vic.gov.au" mdxType="InlineLink" />.
    </p>
    <p>
  This tool is a component of the environment mitigation information system established under section 19 of the{' '}
  <InlineLink text="Melbourne Strategic Assessment (Environment Mitigation Levy) Act 2020" href="https://www.msa.vic.gov.au/melbourne-strategic-assessment-act-2020" mdxType="InlineLink" />
  .
    </p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      